import { CSmartPagination } from "@coreui/react-pro";
import React, { useEffect, useId, useState } from "react";
import "./style.css";

const DEFAULT_PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100];

const clampPage = (value, totalPage) => {
  const parsed = parseInt(value, 10);
  if (Number.isNaN(parsed)) {
    return null;
  }
  const lastPage = Math.max(totalPage || 1, 1);
  return Math.min(Math.max(parsed, 1), lastPage);
};

/**
 * @function CustomPagination
 * @description Pagination with page-size control and direct page jump
 * @returns JSX for CustomPagination
 */
const CustomPagination = ({
  pageNo,
  totalPage,
  pageChangeHanlder,
  limit,
  limitHanlder,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
}) => {
  const jumpInputId = useId();
  const limitSelectId = useId();
  const [jumpValue, setJumpValue] = useState(String(pageNo || 1));

  useEffect(() => {
    setJumpValue(String(pageNo || 1));
  }, [pageNo]);

  const goToPage = (event) => {
    event?.preventDefault?.();
    const nextPage = clampPage(jumpValue, totalPage);
    if (!nextPage) {
      setJumpValue(String(pageNo || 1));
      return;
    }
    setJumpValue(String(nextPage));
    if (nextPage !== pageNo) {
      pageChangeHanlder(nextPage);
    }
  };

  return (
    <div className="pagination-container">
      <CSmartPagination
        align="start"
        activePage={pageNo}
        className="cursor-pointer"
        doubleArrows={true}
        onActivePageChange={pageChangeHanlder}
        pages={totalPage}
      />

      <div className="pagination-actions">
        <form className="page-jump" onSubmit={goToPage}>
          <label htmlFor={jumpInputId} className="pagination-label">
            Go to page
          </label>
          <input
            id={jumpInputId}
            className="page-jump-input"
            type="number"
            min={1}
            max={totalPage}
            value={jumpValue}
            onChange={(event) => setJumpValue(event.target.value)}
            aria-label={`Go to page, 1 to ${totalPage}`}
          />
          <span className="page-jump-total">of {totalPage}</span>
          <button type="submit" className="page-jump-btn">
            Go
          </button>
        </form>

        <div className="limit-container">
          <label htmlFor={limitSelectId} className="pagination-label">
            Items Per Page
          </label>
          <select
            defaultValue={limit}
            name="pagination"
            id={limitSelectId}
            onChange={limitHanlder}
            className="select-container"
          >
            {pageSizeOptions.map((option) => (
              <option className="otption" key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default CustomPagination;
